// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1F-mq","rootCenter":"LoadMoreObserver_rootCenter__2Rr3T","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__jJqTH"};